import dashboardService from "../../../services/dashboardService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_GETTICKETCLOSEDTODAY } from "../../../utils/constants";

const useGetTicketsClosedToday = () =>
  useQuery<number, Error>({
    queryKey: [CACHE_KEY_GETTICKETCLOSEDTODAY],
    queryFn: dashboardService.GetTicketsClosedToday,
  });

export default useGetTicketsClosedToday;
